export { default } from './withEmbedAuthentication'
